import "@/App.css";
import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Gallery from "@/components/Gallery";
import Faq from "@/components/Faq";
import Manifesto from "@/components/Manifesto";
import About from "@/components/About";
import FavoriteCooks from "@/components/FavoriteCooks";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import StickyCTA from "@/components/StickyCTA";
import StatsPage from "@/pages/StatsPage";
import PolicyPage from "@/pages/PolicyPage";
import { track } from "@/lib/analytics";

const SECTION_IDS = ["experience", "manifesto", "favorites", "about", "gallery", "faq", "contact"];

function MainSite() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.08, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    track("pageview");
    const seen = new Set();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !seen.has(entry.target.id)) {
            seen.add(entry.target.id);
            track("section_view", { section: entry.target.id });
          }
        });
      },
      { threshold: 0.25 }
    );
    SECTION_IDS.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      observer.disconnect();
    };
  }, []);

  return (
    <div className="relative min-h-screen bg-ink text-[#FFF5EB] antialiased">
      <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-[70] opacity-[0.035] bg-[radial-gradient(#fff_1px,transparent_1px)] [background-size:16px_16px]"
      />
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Manifesto />
        <FavoriteCooks />
        <About />
        <Gallery />
        <Faq />
        <Contact />
      </main>
      <Footer />
      <StickyCTA />
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#181614",
            border: "1px solid rgba(229, 169, 60, 0.3)",
            color: "#FFF5EB",
          },
        }}
      />
    </div>
  );
}

export default function App() {
  const [stats] = useState(() => window.location.hash === "#/stats");
  const [policy] = useState(() => window.location.pathname === "/policy");
  if (policy) return <PolicyPage />;
  if (stats) return <StatsPage />;
  return <MainSite />;
}
